import React, { useEffect, useState } from 'react';
import {
  getCoachInfoByID,
  verifyCoachProfile,
} from '../../services/apiService';
import RenderProfilePic from '../../extras/RenderProfilePic';
import { getFullName } from '../../utils';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import BasicInfo from './Sections/BasicInfo';
import LoadingCircleIcon from '../../icons/LoadingCircle';
import CoachingExperiene from './Sections/CoachingExperience';
import WorkExperiene from './Sections/WorkExperience';
import EducationInfo from './Sections/EducationInfo';
import Expertise from './Sections/Expertise';
import Skills from './Sections/Skills';
import { useDispatch } from 'react-redux';
import { loadAllUnverifiedCoaches } from '../../redux/actions/coachActions';

export default function VerifyProfile({ user, setVerifyProfile, setLoadData }) {
  const [verifiedData, setVerifiedData] = useState();
  const [unverifiedData, setUnverifiedData] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState({});
  const [disableSave, setDisableSave] = useState({});
  const [disable, setDisable] = useState(true);
  const goBack = () => setVerifyProfile();
  const dispatch = useDispatch();

  useEffect(async () => {
    const data = await getCoachInfoByID(user.userId);
    setVerifiedData(data.verified);
    setUnverifiedData(data.unverified);
  }, [loading]);

  const verifyUser = async () => {
    setLoading({ verify: true });
    const id = user.userId;
    const obj = { ...data, id, action: 'SAVE' };
    if (obj.coachingExperience?.length > 0) {
      const coachingExpList = [];
      obj.coachingExperience?.forEach((exp) => {
        const listOfRoles = exp.coachRoleName;
        delete exp.coachRoleName;
        listOfRoles.forEach((role) => {
          const data = {
            ...exp,
            coachRoleId: role.id,
            coachRoleName: role.name,
          };
          coachingExpList.push(data);
        });
      });
      delete obj.coachingExperience;
      obj.coachingExperience = coachingExpList;
    }
    if (obj?.education && verifiedData?.education) {
      const allEdu = [...obj?.education, ...verifiedData?.education];
      delete obj.education;
      obj.education = allEdu;
    }

    if (obj?.workExperience && verifiedData?.workExperience) {
      const allExp = [...obj?.workExperience, ...verifiedData?.workExperience];
      delete obj.workExperience;
      obj.workExperience = allExp;
    }

    if (obj?.coachingExperience && verifiedData?.coachingExperience) {
      const allExp = [
        ...obj?.coachingExperience,
        ...verifiedData?.coachingExperience,
      ];
      delete obj.coachingExperience;
      obj.coachingExperience = allExp;
    }

    try {
      await verifyCoachProfile(obj);
      goBack();
      await dispatch(loadAllUnverifiedCoaches());
    } catch (err) {
      console.error(err);
    }
    setLoading({ verify: false });
  };

  const holdUser = async () => {
    setLoading({ hold: true });
    const id = user.userId;
    try {
      await verifyCoachProfile({ action: 'HOLD', id });
      goBack();
      await dispatch(loadAllUnverifiedCoaches());
    } catch (err) {
      console.error(err);
    }
    setLoading({ hold: false });
  };

  useEffect(() => {
    if (unverifiedData) {
      if (
        Object.keys(disableSave)?.length ===
          Object.keys(unverifiedData)?.length &&
        !Object.values(disableSave).includes(true)
      ) {
        setDisable(false);
      }
    }
  }, [disableSave]);

  return (
    <div>
      <div>
        <KeyboardBackspaceIcon onClick={() => setVerifyProfile()} />
        <div className='bg-white px-4 py-4 pb-10 my-6'>
          <div className='flex justify-between items-center mt-4'>
            <div className=' flex space-x-3 '>
              <div>
                <RenderProfilePic
                  thumbnail={user.User.thumbnail}
                  name={user.User.firstName}
                  size={3}
                />
              </div>
              <div className='flex flex-col gap-1'>
                <span>{getFullName(user.User)}</span>
                <span>
                  {user.userId} | {verifiedData?.profile.email}
                </span>
              </div>
            </div>
            {user.status === 'ON_HOLD' && (
              <span className=' bg-red-c2 text-red-c3 font-semibold  py-1 px-4 rounded'>
                Hold
              </span>
            )}
            {user.status === 'NEW' && (
              <span className=' bg-yellow-c2 text-yellow-c3 font-semibold py-1 px-6 rounded'>
                New
              </span>
            )}
            {user.status === 'UPDATED' && (
              <span className='bg-blue-c2 text-blue-c3 font-semibold text-center py-1 px-6 rounded'>
                Updated
              </span>
            )}
          </div>

          {unverifiedData?.profile && (
            <div className=' mt-10'>
              <BasicInfo
                user={unverifiedData?.profile}
                data={data}
                setData={setData}
                setDisableSave={setDisableSave}
                disableSave={disableSave}
              />
            </div>
          )}

          {unverifiedData?.coachingExperience?.length > 0 && (
            <div className=' mt-10'>
              <CoachingExperiene
                coachingExperiene={unverifiedData?.coachingExperience}
                data={data}
                setData={setData}
                setDisableSave={setDisableSave}
                disableSave={disableSave}
              />
            </div>
          )}
          {unverifiedData?.workExperience?.length > 0 && (
            <div className=' mt-10'>
              <WorkExperiene
                workExperience={unverifiedData?.workExperience}
                data={data}
                setData={setData}
                setDisableSave={setDisableSave}
                disableSave={disableSave}
              />
            </div>
          )}
          {unverifiedData?.education?.length > 0 && (
            <div className=' mt-10'>
              <EducationInfo
                education={unverifiedData?.education}
                data={data}
                setData={setData}
                setDisableSave={setDisableSave}
                disableSave={disableSave}
              />
            </div>
          )}
          {unverifiedData?.skills && (
            <div className=' mt-10'>
              <Skills
                skills={unverifiedData?.skills}
                data={data}
                setData={setData}
                setDisableSave={setDisableSave}
                disableSave={disableSave}
              />
            </div>
          )}
          {unverifiedData?.domainKnowledge && (
            <div className=' mt-10'>
              <Expertise
                domainKnowledge={unverifiedData?.domainKnowledge}
                gigs={unverifiedData?.gigs}
                data={data}
                setData={setData}
                setDisableSave={setDisableSave}
                disableSave={disableSave}
              />
            </div>
          )}
          <div className='col-span-full flex justify-center gap-8 mt-14'>
            {user.status !== 'hold' && (
              <button
                onClick={holdUser}
                disabled={loading.hold}
                className='border border-gray-300 rounded py-2 w-auto px-4 focus:outline-none'
              >
                {loading.hold && <LoadingCircleIcon iconStyle='w-5 mr-2' />}
                Keep on hold
              </button>
            )}

            <button
              onClick={verifyUser}
              className={`bg-blue-500 text-white rounded py-2 w-28 focus:outline-none disabled:opacity-10 ${
                disable && 'opacity-40 cursor-not-allowed'
              } `}
            >
              {loading.verify && <LoadingCircleIcon iconStyle='w-5 mr-2' />}
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
